import { backend_url, uninterceptedAxiosInstance,qs } from "../common/commonVariables";


export const getAllTimesheet = async (organisationID = "", data) => {
    const query = qs.stringify(
      {
        sort: ["id:desc"],
        startDate: data?.startDate || null,
        endDate: data?.endDate || null,
        team: data?.team || false,
        people: data?.people || false,
        isWeek: data?.isWeek || false,
        isMonth: data?.isMonth || false,
        organisation: organisationID,
      },
      {
        encodeValuesOnly: true,
      }
    );
    try {
      const response = await uninterceptedAxiosInstance.get(
        backend_url + `timesheets?${query}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }
      );
      console.warn(response, "hidad");
  
      let the_response = response.data;
  
      return the_response;
    } catch (err) {
      if (err.response) {
      } else if (err.request) {
      } else {
      }
  
      return {
        status: err.response.status,
        error: err.response?.data?.error,
      };
    }
  };
  